import http from "./httpService.ts";
import {IWorkspaceMemberDto} from "../models/interfaces/dtos/workspaceMembers.dto.interface.ts";

export const fetchWorkspaceMembers = async (workspaceId: string): Promise<IWorkspaceMemberDto[]> => {
  try {
    const response = await http.get(`/api/v1/workspace/${workspaceId}/users`);
    return response.data as IWorkspaceMemberDto[];
  } catch (err) {
    console.log("Error fetching workspace members:", err);
    throw err;
  }
}

export const fetchWorkspaceMember = async (memberId: string): Promise<IWorkspaceMemberDto[]> => {
  try {
    const response = await http.get(`/api/v1/users/lean?id=${memberId}`);
    return response.data as IWorkspaceMemberDto[];
  } catch (err) {
    console.log("Error fetching workspace member:", err);
    throw err;
  }
}